import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  styled,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import { t } from "i18next";
import EditIcon from "@mui/icons-material/Edit";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import NewConsultantDialog from "../../components/staffManagement/NewConsultantDialog";
import TableN from "../../reusableComponents/components/generics/TableN";
import VpnKeyOffOutlinedIcon from "@mui/icons-material/VpnKeyOffOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import Delete from "@mui/icons-material/Delete";
import {
  createNewConsultant,
  deleteConsultant,
  GetConsultantHfInsuree,
  updateConsultant,
} from "../../action";
import { decodeId } from "../../utils/helper";
import DialogBox from "../../reusableComponents/components/dialogs/DialogBox";
import CommonSnackbar from "../../reusableComponents/components/generics/CommonSnackbar";
import { useConvention } from "../../hooks/useConvention";
// import TableN from './TableN'; // Assuming TableN is your table component

const Consultants = ({ insuree_type, newButtonLabel, editButtonLabel }) => {
  const stateM = useSelector((state) => state);
  const [consultantData, setconsultantData] = useState();
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const dispatch = useDispatch();
  const [rowData, setRowData] = useState(null);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState(null);
  const [startCursors, setStartCursors] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState();
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [dropValue, setDropValue] = React.useState(0);
  const [label, setLabel] = React.useState("Enter CAMU No.");

  const { isConventionnementActive } = useConvention()

  const StyledPaper = styled(Paper)(({ theme }) => ({
    ...theme.paper.paper,
  }));

  const StyledPaperHeader = styled(Grid)(({ theme }) => ({
    ...theme.paper.header,
    fontSize: 600,
    padding: ".8rem",
  }));

  const hfid = useSelector(
    (state) =>
      state?.profileReducer?.currentUserResponseData?.i_user?.health_facility_id
  );

  const handleChange = (event) => {
    setDropValue(event.target.value);
    getLabel(event);
  };

  const getLabel = (event) => {
    switch (event.target.value) {
      case 1:
        setLabel(t("EnterCAMUNo."));
        break;
      case 2:
        setLabel(t("EnterFirstName"));
        break;
      case 3:
        setLabel(t("EnterLastName"));
        break;
      case 4:
        setLabel(t("EnterDesignation"));
        break;
      default:
        setLabel(t("EnterCAMUNo."));
        break;
    }
  };

  const searchType = [
    {
      value: 1,
      label: t("camuNo"),
    },
    {
      value: 2,
      label: t("First Name"),
    },
    {
      value: 3,
      label: t("Last Name"),
    },
    {
      value: 4,
      label: t("designation"),
    },
  ];

  const handleClear = () => {
    setSearchValue("");
  };

  useEffect(() => {
    console.log(searchValue); // Logs the updated searchValue
    if (searchValue === "") {
      getApicall();
    }
  }, [searchValue]);

  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);

    params.push(`insureeType: "${insuree_type}"`);

    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (searchValue) {
      if (dropValue == 1) {
        params.push(`insuree_CamuNumber_Icontains: "${searchValue}"`);
      }
      if (dropValue == 2) {
        params.push(`insuree_OtherNames_Istartswith: "${searchValue}"`);
      }
      if (dropValue == 3) {
        params.push(`insuree_LastName_Istartswith: "${searchValue}"`);
      }
      if (dropValue == 4) {
        params.push(`designation_Istartswith: "${searchValue}"`);
      }
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (!!state.healthFacility_Uuid) {
      params.push(`healthFacility_Uuid: "${state?.healthFacility_Uuid}"`);
    }
    return params;
  };
  const getApicall = (row, index) => {
    let params = buildQueryParams({
      filters: filter,
      orderBy: "[insuree]",
      pageSize: pageSize,
      beforeCursor: endCursors,
      afterCursor: startCursors,
      healthFacility_Uuid:
        stateM?.fosaReducer?.pickerHealthFacilityInsurees?.[0]?.uuid,
    });
    dispatch(GetConsultantHfInsuree(params));
  };

  useEffect(() => {
    getApicall();
  }, [pageSize, page]);

  const handleRowDoubleClick = (rowData) => {
    // navigate(`${PORTAL_CONTRACT}/:id=${decodeId(rowData.id)}`);
  };

  const handleDeleteClick = (row, index) => {
    setRowData(row);
    setIndex(index);
    setDeleteDialogOpen(true);
  };

  const handleDeleteAgree = async () => {
    await dispatch(deleteConsultant(decodeId(consultantData[index].id)));
    setTimeout(() => {
      getApicall();
    }, 100);
    setDeleteDialogOpen(false);
    setSnackbarSeverity("success");
    setSnackbarMessage("Consultant Deleted Successfully");
    setSnackbarOpen(true);
  };

  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to the first page when changing page size
    setEndCursors(null);
    setStartCursors(null);
  };

  const handleSearch = () => {
    getApicall();
    // dispatch(GetConsultantHfInsuree(stateM?.fosaReducer?.pickerHealthFacilityInsurees?.[0]?.uuid,searchValue));
  };

  const handleOpen = () => {
    setOpen(true);
    setRowData(null);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setconsultantData(stateM?.fosaReducer?.getConsultantData);
    // setInsureeData(SignInSuccess?.profileReducer?.policyHolderByInsureeResponseData)
    setPageInfo(stateM?.fosaReducer?.getConsultantDataPageInfo?.totalCount);
    setStartCursors(stateM?.fosaReducer?.getConsultantDataPageInfo?.endCursor);
    setEndCursors(stateM?.fosaReducer?.getConsultantDataPageInfo?.startCursor);
  }, [stateM]);

  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };
  const headers = () => {
    var h = [
      t("camuNo"),
      t("firstName"),
      t("lastName"),
      t("Employee No."),
      t("designation"),
      t("specialty"),
      t("Action"),
      t(""),
    ];
    return h;
  };

  const handleEdit = (details, index) => {
    setRowData(details);
    setOpen(true);
    setIndex(index);
  };

  const handleAddConsultant = async (details) => {
    if (
      !details.insureeNo ||
      !details.positionId ||
      !details.specialityId ||
      !stateM?.profileReducer?.insureeByIdResponseData
    ) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Please fill all fields");
      setSnackbarOpen(true);
      return;
    }
    let payload = {
      ...details,
      hfId: hfid,
      insureeId: decodeId(
        stateM?.profileReducer?.insureeByIdResponseData[0].id
      ),
    };
    await dispatch(createNewConsultant({ ...payload, insuree_type }));
    setTimeout(() => {
      getApicall();
    }, 100);
    setOpen(false);
    setSnackbarSeverity("success");
    setSnackbarMessage("Consultant Added Successfully");
    setSnackbarOpen(true);
  };

  const handleUpdateConsultant = async (details) => {
    if (
      !details.insureeNo ||
      !details.positionId ||
      !details.specialityId ||
      !stateM?.profileReducer?.insureeByIdResponseData
    ) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Please fill all fields");
      setSnackbarOpen(true);
      return;
    }

    let payload = {
      id: decodeId(consultantData[index].id),
      specialityId: details.specialityId,
      positionId: details.positionId,
    };
    await dispatch(updateConsultant(payload));
    setTimeout(() => {
      getApicall();
    }, 100);
    setOpen(false);
    setSnackbarSeverity("success");
    setSnackbarMessage("Consultant Updated Successfully");
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = async (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const itemFormatters = () => {
    return [
      (medical, index) =>
        !!medical?.insuree.camuNumber ? medical?.insuree.camuNumber : "",
      (medical, index) =>
        !!medical?.insuree.otherNames ? medical?.insuree.otherNames : "",
      (medical, index) =>
        !!medical?.insuree.lastName ? medical?.insuree.lastName : "",
      (medical, index) =>
        !!medical?.insuree.camuNumber ? medical?.insuree.camuNumber : "",
      (medical, index) =>
        !!medical?.position ? medical?.position?.designation : "",
      (medical, index) =>
        !!medical?.speciality ? medical?.speciality?.designation : "",
      (medical, index) => (
        <IconButton onClick={() => handleEdit(medical, index)}>
          <EditIcon style={{ fontSize: "15px" }} />
        </IconButton>
      ),
      (medical, index) => (
        <IconButton onClick={() => handleDeleteClick(medical, index)}>
          <Delete style={{ color: "red", fontSize: "15px" }} />
        </IconButton>
      ),
    ];
  };

  return (
    <Box>
      <Form
        autoComplete="off"
        onSubmit={(values) => {
          // Handle form submit here
        }}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              style={{
                display: "flex",
                marginLeft: ".5rem",
                marginTop: "1rem",
                marginBottom: "1rem",
              }}
            >
              <Grid className="common-input" item xs={3}>
                <Typography color="#000" fontSize="14">
                  {t("Search Criteria")}
                </Typography>
                <Field
                  name="typeOfSearch"
                  component={Dropdown}
                  options={searchType}
                  input={dropValue}
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
              {dropValue != 0 && (
                <Grid className="common-input">
                  <Typography
                    color="#000"
                    fontSize="24"
                    style={{ paddingBottom: "1px" }}
                  >
                    {t(label)}
                  </Typography>
                  <TextField
                    name="name"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    size="small"
                    type="text"
                    autoComplete="off"
                  />

                  <Button
                    style={{ marginLeft: "20px" }}
                    variant="contained"
                    color="primary"
                    disabled={!searchValue}
                    onClick={handleSearch}
                  >
                    {t("Search")}
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleClear}
                    style={{ marginLeft: "1rem" }}
                  >
                    {t("Clear")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </form>
        )}
      />

      <StyledPaper>
        <StyledPaperHeader container alignItems="center" direction="row">
          <Box
            item
            alignItems="center"
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">
              {t("ConsultantsList")}
            </Typography>
            <Button disabled={!isConventionnementActive} variant="contained" color="primary" onClick={handleOpen}>
              {"+ " + t(newButtonLabel)}
            </Button>
          </Box>
        </StyledPaperHeader>
        <TableN
          headers={headers()}
          itemFormatters={itemFormatters()}
          items={(!!consultantData && consultantData) || []}
          // error={!!errorFullfamilyPendingApproval ? errorFullfamilyPendingApproval : null}
          withSelection={"single"}
          withPagination={true}
          rowsPerPageOptions={[10, 50, 100]}
          defaultPageSize={5}
          page={page}
          pageSize={pageSize}
          count={pageInfo}
          onChangePage={(event, newPage) => {
            setPage(newPage);
            handleNavigation(newPage > page ? "forward" : "backward");
          }}
          onChangeRowsPerPage={handleRowsPerPageChange}
          onDoubleClick={handleRowDoubleClick}
        />
      </StyledPaper>

      <NewConsultantDialog
        title={rowData ? t(editButtonLabel) : t(newButtonLabel)}
        open={open}
        onClose={handleClose}
        onAdd={handleAddConsultant}
        rowData={rowData}
        onUpdate={handleUpdateConsultant}
      />

      {deleteDialogOpen && (
        <DialogBox
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          onAgree={handleDeleteAgree}
          title={t("Confirmation")}
          content={`${t("Do you want to remove consultant- ?")}${
            rowData?.insuree.otherNames
          }`}
          agreeLabel={t("delete")}
          disagreeLabel={t("Cancel")}
        />
      )}

      <CommonSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Box>
  );
};

export default Consultants;
